<template>
    <div>
        <g-table-sync
            :app="app"
            :view="view"
            :columns="columns"
            :default-limit="5"
            :required-filters="routeFilter"
        >
            <template slot="total" slot-scope="{ item }">
                <span>{{ item.total ? item.total + ' €' : '' }}</span>
            </template>
            <template slot="status" slot-scope="{ item }">
                <g-select
                    :item="item._EntityId"
                    :app="app"
                    name="status"
                    :colors="[$colors.blue, $colors.orange, $colors.success]"
                    block
                />
            </template>
            <template slot="factura" slot-scope="{ item }">
                <g-upload
                    accept=".pdf"
                    name="pdf"
                    app="expenses"
                    :item="item._EntityId"
                    :file-name="'factura_asociada_' + item._EntityId + '.pdf'"
                    folder-name="facturas_gastos"
                    :value="item.pdf"
                />
            </template>
        </g-table-sync>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'ProviderTable',
    props: {
        provider: {
            type: String,
            required: true,
        },
        date: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            app: 'expenses',
            view: 'providerExpenseList',
            columns: [
                {
                    title: 'Serie',
                    index: 'serie',
                    order: true,
                    search: true,
                },
                {
                    title: 'Importe',
                    index: 'total',
                    order: true,
                    slot: 'total',
                },
                {
                    title: 'Estado',
                    index: 'status',
                    slot: 'status',
                    order: true,
                },
                {
                    title: 'Factura',
                    slot: 'factura',
                },
            ],
        }
    },
    computed: {
        routeFilter() {
            const date_from = this.date
            const date_to = moment(this.date).endOf('month').format('YYYY-MM-DD')
            return [
                {
                    _ParentOperator: 'AND',
                    _Operator: 'AND',
                    Fields: {
                        provider: {
                            type: 'number',
                            int: Number(this.provider),
                            opt: '=',
                        },
                        invoice_date: {
                            type: 'date',
                            from: date_from,
                            to: date_to,
                        },
                    },
                },
            ]
        },
    },
}
</script>

<style lang="scss" module>

.table {
    tr td:first-child {
        min-width: 120px;
    }

    tr td:last-child {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
}

.dropdown button:first-child {
    background: transparent;
    color: white;
}

.dropdown button:last-child {
    background: rgba(255, 255, 255, 0.4);
    color: white;
}

.dropdown.dropdown-primary {
    button,
    button:hover,
    button:focus {
        border-color: $primary;
    }

    button,
    button:hover,
    button:focus {
        background: $primary;
        color: white;
    }
}

.dropdown.dropdown-warning {
    button,
    button:hover,
    button:focus {
        border-color: $warning;
    }

    button,
    button:hover,
    button:focus {
        background: $warning;
        color: white;
    }
}

.dropdown.dropdown-danger {
    button,
    button:hover,
    button:focus {
        border-color: $danger;
    }

    button,
    button:hover,
    button:focus {
        background: $danger;
        color: white;
    }
}

.table tbody tr:nth-of-type(odd) {
    background: #fff !important;
}

.table tbody tr:nth-of-type(even) {
    background: #f2f4f8 !important;
}

.badgeGroup {
    text-transform: uppercase;
    font-weight: bold;
}
</style>
